import {formateData, get, headers,headerJson, post} from "./index";
import {applicationName} from "../utils";
import request from "../base/request";

/**
 * 获取全部/已发布/已弃用素材
 * @param start
 * @param size
 * @param tabType
 * @param mediaCode
 * @param callBack
 */
export const getMaterialList = (body, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/material/getMaterialList";
    request({url, body, callBack});
};

export const installedPlugin = (callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/material/installedPlugin";
    fetch(url, {
        method: 'GET',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include'
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:installedPlugin",error);
        callBack({installed: false});
    })
};

/**
 * 获取已审核素材列表
 * @param params
 * @param callBack
 */
export const getExaminedList = (params, callBack)=> {
    let url = "/cm-sites-activiti/activiti/examined";
    request({url,contentType: "json", method: "post", params, callBack});
    // fetch(url, {
    //     method: 'POST',
    //     cache: 'no-cache',
    //     headers: {
    //         ...headers,
    //         userName: window.userAccount,
    //         'Content-Type': 'application/json; charset=UTF-8'
    //     },
    //     credentials: 'include',
    //     body: JSON.stringify(params)
    // }).then(response => response.json()).then(data => {
    //     callBack(data);
    // }).catch((error) => {
    //     console.error("actionError:getExaminedList",error);
    //     callBack([]);
    // })
};

/**
 * 获取待我审核素材列表
 * @param start
 * @param size
 * @param tabType
 * @param mediaCode
 * @param callBack
 */
export const getTodoListList = (params, callBack)=> {
    let url = "/cm-sites-activiti/activiti/getNeedProcessed";
    request({url,contentType: "json", method: "post", params, callBack});
    // fetch(url, {
    //     method: 'POST',
    //     cache: 'no-cache',
    //     headers: {
    //         ...headers,
    //         userName: window.userAccount,
    //         'Content-Type': 'application/json; charset=UTF-8'
    //     },
    //     credentials: 'include',
    //     body: JSON.stringify(params)
    // }).then(response => response.json()).then(data => {
    //     // 此处获取的结果集是审核流程中的数据，在未推进流程的情况下，本地数据和流程中数据可能存在差异，需要根据结果集中素材ID在本地数据中再查询一次
    //     console.log("---------getTodoListList----------",data);
    //     let materialIdArray = [];
    //     data.data.map(item =>{
    //         materialIdArray.push(item.data.id);
    //     });
    //     if(materialIdArray.length > 0){
    //         getMaterialByIds({"materialIds":materialIdArray.join(",")},callBack);
    //     }else {
    //         console.info("------getTodoListList------",data);
    //         callBack([]);
    //     }
    // }).catch((error) => {
    //     console.error("actionError:getTodoListList",error);
    //     callBack([]);
    // })
};

const getMaterialByIds = (params, callBack) =>{
    let url = "/cm-sites-" + applicationName() + "/material/getMaterialByIds";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(params)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getMaterialByIds",error);
        callBack([]);
    })
};

/**
 * 获取素材列表
 * @param params
 * @param callBack
 */
export const getStuffList = (params, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/material/getStuffList";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(params)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getStuffList",error);
        callBack([]);
    })
};

/**
 * 获取跳转秀米的地址
 * @param params
 * @param callBack
 */
export const getRedirectXiumi = (params, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/xiumi/redirectxiumi";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(params)
    }).then(response => response.text()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getRedirectXiumi",error);
        callBack("");
    })
};

/**
 * 删除图文
 * @param params
 * @param callBack
 */
export const deleteStuffById = (params, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/material/deleteStuff";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(params)
    }).then(response => response.text()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getRedirectXiumi",error);
        callBack("");
    })
};
// export const deleteById = (params, callBack)=> {
//     let url = "/cm-sites-pms/material/deleteById";
//     fetch(url, {
//         method: 'POST',
//         cache: 'no-cache',
//         headers: headers,
//         credentials: 'include',
//         body: formateData(params)
//     }).then(response => response.text()).then(data => {
//         callBack(data);
//     }).catch((error) => {
//         console.error("actionError:getRedirectXiumi",error);
//         callBack("");
//     })
// };
/**
 * 删除素材
 * @param params
 * @param callBack
 */
export const deleteMaterialById = (params, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/material/deleteMaterialById";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(params)
    }).then(response => response.text()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:deleteMaterialById",error);
        callBack("");
    })
};

/**
 * 保存素材（135编辑器使用）
 * @param params
 * @param callBack
 */
export const saveStuff = (params,callBack) =>{
    let url = "/cm-sites-" + applicationName() + "/material/saveStuff";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            ...headers,
            'Content-Type': 'application/json; charset=UTF-8'
        },
        credentials: 'include',
        body: JSON.stringify(params)
    }).then(response => response.text()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:saveStuff",error);
        callBack("");
    })
};

/**
 * 删除素材中的单个图文
 * @param params
 * @param callBack
 */
export const deleteByStuff = (params, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/material/deleteByStuff";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(params)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:deleteByStuff",error);
        callBack("");
    })
};

/**
 * 获取 stuff
 * @param params
 * @param callBack
 */
export const getStuffById = (params, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/material/getStuffById";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(params)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getStuffById",error);
        callBack("");
    })
};

/**
 * 获取图文
 * @param params
 * @param callBack
 */
export const getStuff = (params, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/material/getStuff";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(params)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getStuff",error);
        callBack("");
    })
};

/**
 * 保存微信素材
 * @param params
 * @param callBack
 */
export const saveMaterial = (params, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/material/saveMaterial";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(params)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:saveMaterial",error);
        callBack({});
    })
};

/**
 * 通过素材ID加载微信素材
 * @param params
 * @param callBack
 */
export const getMaterialById = (params, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/material/getMaterialById";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(params)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:saveMaterial",error);
        callBack("");
    })
};

/**
 * 发送到手机预览
 * @param params
 * @param callBack
 */
export const preview = (params,weiChatCode, callBack)=> {
    let url = "/cm-sites-" + applicationName() + `/material/publish/previewMaterial?weiChatCode=${weiChatCode}`;
     fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headerJson,
        credentials: 'include',
        body: JSON.stringify(params)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:preview",error);
        callBack("");
    })
    // let url = "/cm-sites-" + applicationName() + "/material/previewMaterial";
    // fetch(url, {
    //     method: 'POST',
    //     cache: 'no-cache',
    //     headers: headers,
    //     credentials: 'include',
    //     body: formateData(params)
    // }).then(response => response.json()).then(data => {
    //     callBack(data);
    // }).catch((error) => {
    //     console.error("actionError:preview",error);
    //     callBack("");
    // })
};

/**
 * 更新素材的状态
 * @param params
 * @param callBack
 */
export const saveStatusName = (params, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/material/saveStatusName";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(params)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:saveStatusName",error);
        callBack("");
    })
};


/**
 * 获取微信标签
 * @param params
 * @param callBack
 */
export const getWeChatTags = (params, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/getWeChatTags";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(params)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getWeChatTags",error);
        callBack("");
    })
};

/**
 * 获取当前公众号剩余群发次数
 * @param params
 * @param callBack
 */
export const getWeChatTypeAndMassNumber = (params, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/material/getWeChatTypeAndMassNumber";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(params)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getMassNumber",error);
        callBack("");
    })
};

/**
 * 群发
 * @param params
 * @param callBack
 */
export const sendMaterial = (params, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/material/sendMaterial";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(params)
    }).then(response => response.text()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:sendMaterial",error);
        callBack("");
    })
};


/*跳转到秀米*/

export const synContent = (params, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/xiumi/synContent?userId="+params.id;
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData(params)
    }).then(response => response.text()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:synContent",error);
        callBack("");
    })
};


//保存图文
export const savePicAndArt = (params, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/material/publish/synMaterial";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headerJson,
        credentials: 'include',
        body: JSON.stringify(params)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:synContent",error);
        callBack("");
    })
};


//下载图文
export const downloadMaterial = (params, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/material/downloadMaterial";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headerJson,
        credentials: 'include',
        body: JSON.stringify(params),
    }).then(response => response.blob()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:downloadMaterial",error);
        callBack("");
    })
};


//发布图文
export const publishPicAndArt = (params,tagId, callBack)=> {
    let url = "/cm-sites-" + applicationName() + `/material/publish/publishMaterial?tagId=${tagId}`;
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: headerJson,
        credentials: 'include',
        body: JSON.stringify(params)
    }).then(response => response.text()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:synContent",error);
        callBack("");
    })
};

/**
 * 通过配置获取流程KEY
 * @param params
 * @param callBack
 */
export const getActivitiKeyByconf = (params, callBack)=> {
    let url = "/cm-sites-" + applicationName() + "/mediaTreeActiviti/getByconf";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            ...headers,
            'Content-Type': 'application/json; charset=UTF-8'
        },
        credentials: 'include',
        body: JSON.stringify(params)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getActivitiKeyByconf",error);
        callBack("");
    })
};

/**
 * 加载流程按钮
 * @param params
 * @param callBack
 */
export const loadButtonList = (params, callBack)=> {
    let url = "/cm-sites-activiti/activiti/getButton";
    fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            ...headers,
            userName: window.userAccount
        },
        credentials: 'include',
        body:formateData(params)
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:loadButtonList",error);
        callBack("");
    })
};


